import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetArchivesDocumentPageParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useDocumentsAutoCompleteQuery = (
  options: GetArchivesDocumentPageParams,
) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.document.getArchivesDocumentPageKey(option),
    queryFn: () => api.document.getArchivesDocumentPage(option),
    enabled: option?.keyword !== undefined && option?.keyword.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useDocumentsAutoCompleteQuery;
